import * as e from "react";
import c from "../lib/IconBase.es.js";
import t from "../defs/PlayCircle.es.js";
const o = e.forwardRef((r, a) => /* @__PURE__ */ e.createElement(c, { ref: a, ...r, weights: t }));
o.displayName = "PlayCircleIcon";
const m = o;
export {
  m as PlayCircle,
  o as PlayCircleIcon
};
